import React from 'react'
import Cases_Comp from '../../Components/Cases/Cases';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function Cases() {
  return (
    <Dashboard_Comp>
    <Cases_Comp />
    </Dashboard_Comp>
  )
}

export default Cases;